import i18n from "../../../../../i18n"
import ArrayTable from "../../../../../UI/ArrayTable/ArrayTable"
import {euroFormatter, imageFormatter} from "../../../../../functions/Formatters/formatters"

const formatQuantity = (value) => {
    if (value === null || value === undefined || value === '') {
        return value
    }
    const text = String(value)
    if (!text.includes('.')) {
        return text
    }
    const trimmed = text.replace(/0+$/, '').replace(/\.$/, '')
    return trimmed === '' || trimmed === '-' ? '0' : trimmed
}

const ReservationPrice = (props) => {
    const table = {
        'product_object.image_object':{
            'label': '',
            'formatter': (value, row, id) => {
                if(value){
                    return <img className="small-image" src={value.image_webp} />
                }
            },
        }, 
        'description':{
            'label': i18n.t('Omschrijving'),
            'formatter': (value, row, id) => {
                if(row.parent_line){
                    return <span className="ps-2">+ {value}</span>
                }
                return <span className="">{value}</span>
            }
        }, 
        'quantity':{
            'label': i18n.t('Aantal'),
            'formatter': (value, row, id) => {
                if(row.unit === 'pc'){
                    return <span className="ps-2">{value * 100}%</span>
                }
                return <span className="">{formatQuantity(value)}</span>
            }
        }, 
        'amount_in_vat': {
            'label': i18n.t('Bedrag'),
            'formatter':euroFormatter,
            'className':'text-end'
        },       
    }
    const reservationLines = props.data?.reservationline_objects || []
    const totalAmount = props.data?.total_amount_in_vat ?? props.data?.calc_total_amount_in_vat ?? props.data?.total_amount
    if(reservationLines.filter(line => line.people > 0).length > 0){
        table['people'] = {
            'label': i18n.t('Gasten')
        }
    }

    const lines = <ArrayTable className="reservation-table table table-hover m-0" data={reservationLines.filter(line => (line.total_amount_in_vat ?? line.amount_in_vat) !== 0)} fields={table} >
            {/* <tr> <td colSpan={'100%'} className="text-end"> {i18n.t('Subtotaal')}: {euroFormatter(props.data.total_amount_ex_vat)}</td> </tr>
            <tr> <td colSpan={'100%'} className="text-end"> {i18n.t('BTW')}: {euroFormatter(props.data.total_amount_vat)}</td> </tr> */}
            <tr> <td colSpan={'100%'} className="text-end"> {i18n.t('Totaal')}: {euroFormatter(totalAmount)}</td> </tr>
        </ArrayTable>
    return <>
        {lines}

    </>
}

export default ReservationPrice